<div class="card flex-grow mb-0 product-creation-wizard" style="margin: 0 15px 15px; background-color: transparent">
  <div class="content-area-wrapper" style="height: 87vh; gap: 16px">
    <div class="card" style="width: 400px">
      <app-layout-steps-client
        [steps]="steps"
        [currentStep]="currentStep"
        (goBack)="retour()"
        (stepSelected)="onTimelineStepSelected($event)">
      </app-layout-steps-client>
    </div>

    <div class="card content-right custom-scroll" style="overflow: auto; flex: 1">
      <div class="content-wrapper p-0 content-right-r">
        <div class="card-body">
          <div class="wizard-content">
            <div *ngIf="currentStep === 0" class="step-form">
              <h4 class="mb-2">Activer le module logiciel de caisse</h4>
              <p class="text-muted mb-3">
                Le module permet de synchroniser les tickets, entrepôts et caisses avec
                <strong>back-logiciel-caisse</strong> pour la station <strong>{{ code_station }}</strong>.
              </p>
              <div class="form-section rounded p-3">
                <div class="form-check mb-3">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id="lc-module-activate"
                    [(ngModel)]="acceptActivation" />
                  <label class="form-check-label" for="lc-module-activate">
                    J’active le module logiciel de caisse pour cette entreprise
                  </label>
                </div>
                <ul class="text-muted small mb-0 ps-3">
                  <li>Consultation des tickets caisse depuis l’ERP vente</li>
                  <li>Connexion sécurisée au back logiciel caisse</li>
                  <li>Synchronisation temps réel (WebSocket)</li>
                </ul>
              </div>
              <div class="d-flex justify-content-end mt-3">
                <button type="button" class="btn btn-primary" (click)="activateModule()">
                  Activer et continuer
                </button>
              </div>
            </div>

            <div *ngIf="currentStep === 1" class="step-form">
              <h4 class="mb-2">Créer un accès logiciel caisse</h4>
              <p class="text-muted mb-3">
                Le module est activé. Créez maintenant les identifiants qui permettront à l’ERP
                de se connecter au logiciel de caisse.
              </p>
              <div class="form-section rounded p-3 text-center py-4">
                <div class="mb-3">
                  <i data-feather="key" style="width: 40px; height: 40px; color: #7367f0"></i>
                </div>
                <p class="mb-4">
                  Vous allez définir un email et un mot de passe dédiés au logiciel caisse
                  (distincts ou identiques à votre compte ERP).
                </p>
                <button type="button" class="btn btn-primary" (click)="goToCreateAcces()">
                  Créer l’accès logiciel caisse
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
